module.exports = __webpack_public_path__ + "static/media/card-design-special-delivery.13048f1d.png";